import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { prepareDraft } from "state/actions/drafts"

export const useResponseApi = () => {
  const dispatch = useDispatch()
  return {
    prepareDraft: bindActionCreators(prepareDraft, dispatch),
  }
}
